import { useDashboardToAddToFromParam } from '@modules/analysis/hooks';
import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { CanAccess } from '@modules/common/components/CanAccess';
import { useGetDashboardTypeDisplayNameFromURLParam } from '@modules/common/hooks';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';
import { LoadingButton } from '@mui/lab';
import { Skeleton, Stack, Tooltip } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { shallow } from 'zustand/shallow';
interface SaveButtonProps {
  isDisabled?: boolean;
  isLoading?: boolean;
  onSave: () => void;
  className?: string;
  disabledStateTooltipTitle: string;
}

export const SaveButton = ({
  isDisabled,
  isLoading,
  onSave,
  className,
  disabledStateTooltipTitle,
}: SaveButtonProps) => {
  const { isLoading: isAnalysisLoading } = useAnalysisStore(
    ({ useCase, isLoading }) => ({ useCase, isLoading }),
    shallow,
  );

  const { dashboardToAddToFromParam } = useDashboardToAddToFromParam();
  const dashboardTypeDisplayName = useGetDashboardTypeDisplayNameFromURLParam();

  const activeButtonTooltipTitle = `Save Quantify`;

  const tooltipTitle = isDisabled
    ? disabledStateTooltipTitle
    : activeButtonTooltipTitle;

  return (
    <Tooltip title={tooltipTitle} placement="bottom" disableInteractive>
      <Stack>
        <CanAccess
          resource={PermissionResource.Artefact}
          operation={PermissionOperation.Write}
        >
          {/* We render Skeleton while the analysis in loading state,
          on analysis is loaded, we render LoadingButton which has a
          prop called 'loading' to handle loading state of the button
          when any action is being performed */}
          {isAnalysisLoading ? (
            <Skeleton variant="rectangular" width={92} height={40} />
          ) : (
            <LoadingButton
              variant="outlined"
              onClick={onSave}
              loading={isLoading}
              disabled={isDisabled || isLoading}
              loadingPosition="start"
              startIcon={<BookmarkRoundedIcon />}
              className={className}
            >
              Save
              {dashboardToAddToFromParam
                ? ` & add to ${dashboardTypeDisplayName}`
                : ''}
            </LoadingButton>
          )}
        </CanAccess>
      </Stack>
    </Tooltip>
  );
};
